angular.module('b2bLoginApp.services').factory('Loading', ["promiseTracker", function(promiseTracker) {
    return promiseTracker();
}]);
